import { useEffect, useMemo } from 'react'

const Notification = ({
  notifications,
  setNotifications,
  positionClassName = 'top-0 end-0 p-3',
  style = { zIndex: 9999 }
}) => {
  const getNotificationKey = (notification) => `${notification?.type || 'success'}|${notification?.message || ''}`

  const uniqueNotifications = useMemo(() => {
    const seen = new Set()
    return notifications.filter((notification) => {
      const key = getNotificationKey(notification)
      if (seen.has(key)) return false
      seen.add(key)
      return true
    })
  }, [notifications])

  const removeNotification = (notificationToRemove) => {
    const keyToRemove = getNotificationKey(notificationToRemove)
    setNotifications((prev) =>
      prev.filter((notification) => getNotificationKey(notification) !== keyToRemove)
    )
  }

  useEffect(() => {
    const timers = uniqueNotifications.map((notification, index) => {
      return setTimeout(() => {
        removeNotification(notification)
      }, 3000 + index * 1000)
    })

    return () => {
      timers.forEach((timer) => clearTimeout(timer))
    }
  }, [uniqueNotifications])

  return (
    <div className={`notification position-fixed ${positionClassName}`} style={style}>
      {uniqueNotifications.map((notification) => {
        let variant = 'success'
        let icon = 'bi-check-circle-fill'

        if (notification.type === 'error' || notification.type === 'danger') {
          variant = 'danger'
          icon = 'bi-exclamation-triangle-fill'
        } else if (notification.type === 'warning') {
          variant = 'warning'
          icon = 'bi-exclamation-triangle-fill'
        }

        return (
          <div
            key={notification.id}
            className={`alert alert-${variant} d-flex align-items-center shadow-sm fade show mb-2 p-3`}
            role="alert"
          >
            <i className={`bi ${icon} me-2`}></i>
            <div>{notification.message}</div>
          </div>
        )
      })}
    </div>
  )
}

export default Notification
